import React from "react";
export default function Input(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...props}
      className={[
        "h-[38px] w-full rounded-[8px] border",
        "border-[#D6DADF] bg-white px-3 text-sm outline-none",
        "focus:border-[#B5BBC2] placeholder:text-black/50",
        props.className || ""
      ].join(" ")}
    />
  );
}
